import React from 'react';

import Theme from 'styles/theme';

const SustainabilityPageSectionPlaceholder = () => (
  <div className="SustainabilityPageSectionPlaceholder">
    <style jsx>
      {`
        .SustainabilityPageSectionPlaceholder {
          width: 100%;
          height: 200px;
          background-color: ${Theme.get('colors-grey')};
        }
      `}
    </style>
  </div>
);

SustainabilityPageSectionPlaceholder.propTypes = {};

export default SustainabilityPageSectionPlaceholder;
